import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, tokenRequest } from "./AuthConfig";

const msalInstance = new PublicClientApplication(msalConfig);

export const getAuthToken = async () => {
    await msalInstance.initialize();
    
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length <= 0) throw new Error("Usuário não autenticado");

    try {
        const response = await msalInstance.acquireTokenSilent({
            ...tokenRequest,
            account: accounts[0]
        });
        return response.accessToken;
    } catch (error) {
        console.log(error)
    }
};